
export { input } from "/vercel/path0/styled-system/recipes/input.mjs"